<template>

  <HeaderSection />

  <section id="formulario" class="bg-gray-100 py-12" style="font-family: PantonRegular;">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700"
      @invalid-submit="onInvalidSubmit">

      <div class="container mx-auto px-4 max-w-5xl pb-16">

        <h1 class="font-bold text-gray-800 mb-4 text-2xl text-center" style=" font-family: PantonBold;">
          POR FAVOR COMPLETE EL FORMULARIO PARA ADQUIRIR SU ENTRADA.<br>
        </h1>

        <h1 class="font-bold text-gray-800 mb-4 text-lg text-center" v-if="!isFree">
          UNA VEZ COMPLETADO EL FORMULARIO SERA REDIRIGIDO A MERCADOPAGO PARA REALIZAR EL PAGO.
        </h1>

        <h1 class="font-bold text-gray-800 mb-4 text-lg text-center text-uppercase" v-if="isFree">
          Una vez completado el formulario, te encontrarás inscripto al evento
        </h1>

        <h1 class="font-bold text-gray-800 mb-4 text-lg text-center pb-5">
          La entrada es personal e intransferible
        </h1>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 text-center" v-if="!isFree">
            <label v-if="!producto" class="block mb-3 font-bold text-3xl text-red-600">ENTRADAS AGOTADAS</label>
            <label class="block mb-3 font-bold text-3xl"> <span v-if="producto">ENTRADA :{{
              producto.descripcion.toUpperCase() }}</span>
            </label>
            <label class="block mb-3 font-bold text-3xl">
              <span v-if="producto"> VALOR : </span>
              <span v-if="producto && producto.precioUnitario == 220000"> $ 220.000&nbsp;</span>
              <span class="line-through text-red-600 " v-if="producto && producto.precioUnitario < 220000"> $
                220.000&nbsp;</span>
              <span v-if="producto && producto.precioUnitario < 220000" class="text-green-600">{{ ' $ ' +
                formatNumber(producto.precioUnitario) }}</span>
            </label>
          </div>
          <div class="w-full px-2 text-center" v-if="isFree">
            <label class="block mb-3 font-bold text-3xl">Invitación exclusiva sin cargo</label>
          </div>
        </div>

        <div
          class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3 bg-gray-200 rounded-lg border border-gray-800 px-2 py-6 shadow-md">
          <div class="w-full px-2 text-center">
            <label class="block mb-3">Si posee un código de descuento ingreselo aquí (Opcional)</label>
            <Field name="codigoDescuento" v-slot="{ field, errors }" v-model="formData.codigoDescuento">
              <InputText v-bind="field" type="text" @blur="validarCodigoDescuento" placeholder="Código de descuento"
                class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="codigoDescuento" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-8">

          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Documento</label>
            <Field name="documento" v-slot="{ field, errors }" v-model="formData.documento">
              <InputText v-bind="field" type="text" @blur="validarDni" placeholder="Ingrese su documento"
                class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="documento" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Email</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="text" placeholder="Ingrese su email" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field, errors }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" placeholder="Ingrese su nombre" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field, errors }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" placeholder="Ingrese su apellido" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="apellido" />
              </span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">País</label>
            <Select v-model="selectedCountry" filter :options="paises" optionLabel="value"
              placeholder="Select a Country" class="input-base" />
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-if="selectedCountry !== null" v-model="selectedCountry.code" class="input-base"
              readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field, errors }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="codigoArea" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field, errors }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="telefonoCelular" />
              </span>
            </Field>
          </div>
        </div>
        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Empresa</label>
            <Field name="empresa" v-slot="{ field, errors }" v-model="formData.empresa">
              <InputText v-bind="field" type="text" placeholder="Ingrese su empresa" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="empresa" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-6/12">
            <label class="block mb-1">Provincia</label>
            <Field name="provincia" v-slot="{ handleChange, handleBlur, value, errors }" v-model="formData.provincia">
              <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                placeholder="Seleccione la provincia" :options="provincias" optionLabel="descripcion" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="provincia" />
              </span>
            </Field>


          </div>
        </div>


        <template v-if="!isFree">
          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-6">
            <div class="w-full px-2">
              <h2 class="font-bold text-gray-700 text-lg border-b border-gray-300 pb-2 mb-4">Datos de Facturación</h2>
            </div>
          </div>

          <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-2">
            <div class="w-full px-2 md:w-6/12">
              <label class="block mb-1">Condición de IVA</label>
              <Field name="condicionIva" v-slot="{ handleChange, handleBlur, value, errors }"
                v-model="formData.condicionIva">
                <Select @blur="handleBlur" @update:model-value="handleChange" :model-value="value"
                  placeholder="Seleccione condición de IVA" :options="condicionesIva" optionLabel="descripcion"
                  class="input-base"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && value !== undefined, 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="condicionIva" />
                </span>
              </Field>
            </div>
            <div class="w-full px-2 md:w-6/12">
              <label class="block mb-1">CUIT</label>
              <Field name="cuit" v-slot="{ field, errors }" v-model="formData.cuit">
                <InputMask v-bind="field" mask="99-99999999-9" placeholder="XX-XXXXXXXX-X" class="input-base"
                  :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
                <span class="text-sm text-red-500 p-error">
                  <ErrorMessage name="cuit" />
                </span>
              </Field>
            </div>
          </div>
        </template>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-shopping-cart mr-2"></i>{{ isFree ? 'ADQUIRIR ENTRADA' : 'COMPRAR' }}
          </button>
        </div>

      </div>
    </Form>

    <BlockUI :blocked="isSubmitting" fullScreen />

  </section>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import HeaderSection from './HeaderSection.vue';

import InputText from 'primevue/inputtext';
import InputMask from 'primevue/inputmask';
import Select from 'primevue/select';
import BlockUI from 'primevue/blockui';

import jsonCountries from '@/data/countries.json';
import jsonProvincias from '@/data/provincias.json';
import jsonCondicionesIva from '@/data/condicionesIva.json';

import pagosServices, { Producto } from 'qreventos-suite/pagos';
import suiteService, { Acreditado, EstadoAcreditado, Invitacion, OrigenAcreditado, TipoAcreditado } from 'qreventos-suite/services';
import invitacionService from 'qreventos-suite/invitaciones';

import suiteConfig from '@/services/suite.config';
import { A_VERIFICAR, SAVE, ORIGEN_ACREDITADO, VERIFICADO } from "qreventos-suite/constantes";

interface Pais {
  code: string;
  value: string;
}

interface Provincia {
  id: string;
  descripcion: string;
}

interface CondicionIva {
  id: string;
  descripcion: string;
}

export default defineComponent({
  components: {
    HeaderSection,
    InputText, InputMask, Select, BlockUI,
    Field, ErrorMessage, Form
  },
  created() {
    document.title = "Foro Vaca Muerta - Acreditación"
  },
  data() {
    return {
      isSubmitting: false,
      paises: jsonCountries as Pais[],
      selectedCountry: { "code": "+54", "value": "Argentina" } as Pais,
      provincias: jsonProvincias as Provincia[],
      selectedProvincia: undefined as unknown as Provincia,
      condicionesIva: jsonCondicionesIva as CondicionIva[],
      producto: undefined as unknown as Producto,
      acreditado: undefined as unknown as Acreditado,
      productos: [] as Producto[],
      isFree: false,
      formData: {
        nombre: '',
        apellido: '',
        documento: '',
        mail: '',
        codigoArea: '',
        telefonoCelular: '',
        empresa: '',
        codigoDescuento: '',
        provincia: undefined as unknown as Provincia,
        condicionIva: undefined as unknown as CondicionIva,
        cuit: '',
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        nombre: yup.string().required('Ingrese su nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingrese su apellido').min(2, 'Al menos 2 letras'),
        mail: yup.string().required('Ingrese el correo').email('Correo inválido'),
        documento: yup.string().required('Ingrese su número de documento').min(8, 'Al menos 8 números'),
        codigoArea: yup.string().required('Ingrese el código de área').min(2, 'Al menos 2 números'),
        telefonoCelular: yup.string().required('Ingrese el número de celular').min(5, 'Al menos 5 números'),
        empresa: yup.string().required('Ingrese su empresa').min(2, 'Al menos 2 letras'),
        condicionIva: this.isFree ? yup.object().nullable() : yup.object().required('Seleccione la condición de IVA'),
        cuit: this.isFree ? yup.string().nullable() : yup.string().required('Ingrese su CUIT').min(13, 'CUIT inválido'),
      });
    }
  },
  methods: {
    async pagar() {
      if (this.acreditado.dato3 != '41') {
        let productosDisponibles = await pagosServices.findProductosDisponiblesBy(suiteConfig.evento);

        let productosDisponible = productosDisponibles.find(p => p.id.toString() === this.acreditado.dato3) as Producto;
        if (!productosDisponible || productosDisponible.cantidadDisponible <= 0) {
          this.isSubmitting = false;
          Swal.fire(
            {
              title: this.acreditado.dato4 + " - AGOTADO",
              text: 'El descuento  ' + this.acreditado.dato4 + ' no tiene más unidades disponibles, deberá abonar el valor completo del producto.',
              icon: "error",
              confirmButtonText: "Pagar valor completo $220.000",
            }).then(() => {
              this.producto = this.productos.find(p => p.id === 41) as Producto;
              this.redirigirMercadoPago();
            });
          return;
        }
        this.producto = productosDisponible;
      }

      this.redirigirMercadoPago();
    },
    async redirigirMercadoPago() {
      const ordenCompra: Object = {
        ordenCompra: {
          acreditado: { id: this.acreditado.id },
          itemsOrdenCompra: [
            {
              producto: { id: this.producto.id },
              cantidad: 1,
              precioUnitario: this.producto.precioUnitario,
              subtotal: this.producto.precioUnitario,
            },
          ],
          total: this.producto.precioUnitario,
        }
      };
      let responseObj = await pagosServices.pagar(suiteConfig.evento, this.acreditado.hash, ordenCompra);
      const response = new Map<string, string>(Object.entries(responseObj));
      const formUrl = response.get("formUrl");
      if (formUrl) {
        window.location.href = formUrl;
      }
    },
    onInvalidSubmit(values: any) {
      const errores: number = Object.values(values?.errors || {}).flat().length;
      Swal.fire({ title: "Hay errores", html: "Por favor revise el formulario (" + errores + " error/es)", icon: "error" });
    },
    async validarCodigoDescuento() {

      try {
        this.isFree = false;
        this.producto = this.productos.find(p => p.id == 41) as Producto;
        if (this.formData.codigoDescuento.trim() == '') {
          return
        }
        this.isSubmitting = true;
        var invitacion: Invitacion = await invitacionService.findInvitacionBy(suiteConfig.evento, this.formData.codigoDescuento);
        this.isSubmitting = false;
        if (!invitacion) {
          this.formData.codigoDescuento = '';
          Swal.fire({ title: "Error", text: 'Código de descuento inválido', icon: "error" });
          return;
        }

        if (invitacion.cantidadDisponibles < 0) {
          this.formData.codigoDescuento = '';
          Swal.fire({ title: "Error", text: 'El código de descuento no tiene más usos disponibles', icon: "error" });
          return;
        }

        if (this.formData.codigoDescuento == 'EARLYBIRD150') {
          this.producto = this.productos.find(p => p.id == 39) as Producto;
        } else if (this.formData.codigoDescuento == 'PREACCESS180') {
          this.producto = this.productos.find(p => p.id == 40) as Producto;
        } else if (this.formData.codigoDescuento.endsWith("-110K")) {
          this.producto = this.productos.find(p => p.id == 43) as Producto;
        } else if (this.formData.codigoDescuento.endsWith("-150K") || this.formData.codigoDescuento == "EXPOCONS") {
          this.producto = this.productos.find(p => p.id == 42) as Producto;
        } else if (this.formData.codigoDescuento.endsWith("-FREE")) {
          this.isFree = true;
          return;
        }

        if (!this.producto) {
          this.producto = this.productos.find(p => p.id == 41) as Producto;
          this.formData.codigoDescuento = '';
          Swal.fire({ title: "DESCUENTO AGOTADO", text: 'El código de descuento esta agotado.', icon: "error" });
          return;
        }

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
      finally {
        this.isSubmitting = false;
      }
    },
    async validarDni() {
      this.isSubmitting = true;

      try {
        let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.documento) as Acreditado;
        this.isSubmitting = false;
        if (acreditadoExistente) {
          if (acreditadoExistente.estadoAcreditado.id === A_VERIFICAR) {
            this.acreditado = acreditadoExistente;
            Swal.fire({
              title: "Atención",
              html: "Usted ya se encuentra registrado, pero su pago esta pendiente.<br><b>A continuación será redirigido a MercadoPago para pagar la entrada.</b><br>Gracias.",
              icon: "success",
              confirmButtonText: "Pagar ahora",
            }).then(async () => {
              await this.pagar();
            });
          } else {
            Swal.fire({
              title: "Atención",
              html: "El documento ingresado ya esta confirmado para el evento.",
              icon: "warning"
            }).then(() => {
              this.isSubmitting = false;
            });
          }
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    },
    async onSubmit() {
      this.isSubmitting = true;

      let acreditadoExistente: Acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "dni=" + this.formData.documento) as Acreditado;
      if (acreditadoExistente) {
        this.isSubmitting = false;
        if (acreditadoExistente.estadoAcreditado.id === A_VERIFICAR) {
          this.acreditado = acreditadoExistente;
          Swal.fire({ title: "Atención", html: "Usted ya se encuentra registrado, pero su pago esta pendiente.<br><b>A continuación será redirigido a MercadoPago para pagar la entrada.</b><br>Gracias.", icon: "success", }).then(async () => {
            await this.pagar();
          });
        } else {
          Swal.fire({ title: "Atención", html: "El documento ingresado ya esta confirmado para el evento.", icon: "warning" }).then(() => {
            this.isSubmitting = false;
          });
        }
        return;
      }

      if (!this.producto) {
        this.isSubmitting = false;
        Swal.fire({ title: "DESCUENTO AGOTADO", text: 'El código de descuento esta agotado.', icon: "error" });
        return;
      }

      try {

        if (!this.isFree) {
          Swal.fire({ title: "CUPO COMPLETO", html: 'Gracias por tu interés en participar del Foro de Inversiones Vaca Muerta. El evento ya tiene su capacidad completa.<br/><br/>Podrás seguir todo el evento vía streaming.<br/>Anotate en <a href="www.forovacamuerta.com/streaming" target="_blank" class="text-blue-500 underline">www.forovacamuerta.com/streaming</a>', icon: "error" });  
        }

        this.acreditado = new Object() as Acreditado;

        let invitacion: Invitacion = undefined as unknown as Invitacion;
        if (this.formData.codigoDescuento != "") {
          invitacion = await invitacionService.findInvitacionBy(suiteConfig.evento, this.formData.codigoDescuento);
          if (invitacion != null && invitacion.codigoInvitacion.endsWith("-FREE")) {
            this.isFree = true;
          } else {
            this.isFree = false;
          }
        } else {
          this.isFree = false;
        }

        var estadoAcreditado: EstadoAcreditado = { "id": A_VERIFICAR } as EstadoAcreditado;

        this.acreditado.tipoAcreditado = { "id": 2327 } as TipoAcreditado;
        this.acreditado.estadoAcreditado = estadoAcreditado
        this.acreditado.mail = this.formData.mail;
        this.acreditado.dni = this.formData.documento;
        this.acreditado.nombre = this.formData.nombre;
        this.acreditado.apellido = this.formData.apellido;
        this.acreditado.empresa = this.formData.empresa;

        this.acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.telefonoCelular;
        this.acreditado.origenAcreditado = { "id": ORIGEN_ACREDITADO } as OrigenAcreditado;
        this.acreditado.modificado = SAVE;
        if (this.formData.provincia) {
          this.acreditado.dato1 = this.formData.provincia.id;
        }
        this.acreditado.dato2 = this.producto.precioUnitario.toString();
        this.acreditado.dato3 = this.producto.id.toString();
        this.acreditado.dato4 = this.producto.descripcion;
        if (!this.isFree) {
          this.acreditado.dato5 = this.formData.condicionIva.id;
          this.acreditado.dato6 = this.formData.cuit;
        }
        if (invitacion) {
          this.acreditado.invitacion = invitacion;
        }
        this.acreditado.cantidad = 1;
        this.acreditado.notificar = true;
        this.acreditado.notificarWhatsApp = false;

        if (this.isFree) {
          this.acreditado.tipoAcreditado = { "id": 2351 } as TipoAcreditado;
          this.acreditado.estadoAcreditado = { "id": VERIFICADO } as EstadoAcreditado;
          this.acreditado.dato2 = "0";
          this.acreditado.dato3 = "";
          this.acreditado.dato4 = "INVITACION - SIN COSTO";
        }

        this.acreditado = await suiteService.saveOrUpdate(suiteConfig.evento, this.acreditado);
        this.isSubmitting = false;

        if (this.acreditado && !this.isFree) {
          this.acreditado = await suiteService.findAcreditadoByFilters(suiteConfig.evento, "id=" + this.acreditado.id);
          Swal.fire({ title: "Registro completado", html: "Recibimos sus datos correctamente.<br/><br/><b>A continuación será redirigido a MercadoPago para abonar la entrada.</b>", icon: "success", confirmButtonText: "Pagar ahora" }).then(async () => {
            await this.pagar();
          });
        } else if (this.acreditado) {
          Swal.fire({
            title: "Registro completado",
            html: "Hemos recibido sus datos de registración con éxito.<br/><br/>Le enviamos un mail con su QR para concurrir al evento.<br/><br/>Por favor revise su casilla de correo y de spam.",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            window.location.href = "https://www.forovacamuerta.com";
          });
        }
      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      } finally {
        this.isSubmitting = false;
      }
      return;
    },
    formatNumber(value: number) {
      if (!value) return "0";
      return new Intl.NumberFormat('es-AR').format(value);
    }
  },
  async mounted() {
    this.productos = await pagosServices.findProductosDisponiblesBy(suiteConfig.evento);
    this.producto = this.productos.find(p => p.id === 41) as Producto;
    if (!this.producto || this.producto.cantidadDisponible <= 0) {
      Swal.fire(
        {
          title: "Entradas agotadas",
          text: 'Lamentamos informarle que las entradas se encuentran agotadas.',
          icon: "error"
        });
    }

    if (this.$route.query.codigo) {
      this.formData.codigoDescuento = this.$route.query.codigo as string;
      await this.validarCodigoDescuento();
    } else {
      this.$router.push({ path: '/finalizado' }).then(() => { this.$router.go(0) });
    }
  }
});
</script>